<template>
  <oie-my-pages-template :title="t('invoiceHistoryTitle')" :text="t('invoiceHistorySubTitle')" class="my-invoice-history">
    <div>
      <div class="my-invoice-history__filter-grid">
        <!-- Sök o lägg till artiklar -->
        <oie-base-input
          id="my-invoice-history-search-invoice"
          v-model="searchPhrase"
          :label-text="t('invoiceHistorySearchLabel')"
          epi-edit="'SearchPhraseDescription'"
          :placeholder="t('invoiceHistorySearchPlaceholder')"
          class="my-invoice-history__search-input"
          @input="search"></oie-base-input>

        <div class="input my-invoice-history__date-inputs">
          <label v-epi-edit="'FromDateHeader'" for="invoice-history-search-date-from" class="input__label">{{ t('invoiceHistoryFromDateLabel') }}</label>

          <div class="input__container">
            <datepicker
              ref="fromDate"
              v-model="fromDate"
              :placeholder="t('invoiceHistoryFromDateLabel')"
              :monday-first="true"
              wrapper-class="datepicker"
              calendar-class="datepicker-calendar"
              input-class="datepicker-input"
              format="yyyy-MM-dd"
              :language="languages[0]"
              :full-month-name="true"
              @input="search"></datepicker>
          </div>
        </div>

        <div class="input my-invoice-history__date-inputs">
          <label v-epi-edit="'ToDateHeader'" for="invoice-history-search-date-from" class="input__label">{{ t('invoiceHistoryToDateLabel') }}</label>

          <div class="input__container">
            <datepicker
              v-model="toDate"
              :placeholder="t('invoiceHistoryToDateLabel')"
              :monday-first="true"
              wrapper-class="datepicker"
              calendar-class="datepicker-calendar"
              input-class="datepicker-input"
              format="yyyy-MM-dd"
              :language="languages[0]"
              :full-month-name="true"
              @input="search"></datepicker>
          </div>
        </div>
      </div>

      <section>
        <div class="my-invoice-history__heading-and-filter-actions">
          <h3 v-epi-edit="'OrderListHeader'" class="my-invoice-history__column-header">
            {{ t('invoiceListHeader') }}
          </h3>

          <oie-base-radio-checkbox
            v-model="showInvoicesFilter"
            value="All"
            class="show-invoice-filter-radio"
            :label="t('showAllInvoicesFilterLabel')"
            @change="search">
          </oie-base-radio-checkbox>

          <oie-base-radio-checkbox
            v-model="showInvoicesFilter"
            value="Open"
            class="show-invoice-filter-radio"
            :label="t('showOpenInvoicesFilterLabel')"
            @change="search">
          </oie-base-radio-checkbox>

          <oie-base-radio-checkbox
            v-model="showInvoicesFilter"
            value="Due"
            class="show-invoice-filter-radio"
            :label="t('showDueInvoicesFilterLabel')"
            @change="search">
          </oie-base-radio-checkbox>
        </div>

        <div class="my-invoice-history__table">
          <oie-invoice-history-table v-element-loader="{ endpoint: 'invoice/search' }" :invoices="invoices" :invoices-filter="showInvoicesFilterParam"></oie-invoice-history-table>
        </div>
      </section>
    </div>
  </oie-my-pages-template>
</template>

<script>
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import { sv, de, sr } from 'vuejs-datepicker/dist/locale'
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  components: {
    Datepicker
  },

  data() {
    return {
      invoices: [],
      languages: [sv, de, sr],
      fromDate: null,
      toDate: null,
      searchPhrase: '',
      showInvoicesFilter: 'All',
      moreToGet: false
    }
  },
  computed: {
    showInvoicesFilterParam() {
      if (this.showInvoicesFilter === 'Open') {
        return true
      } else if (this.showInvoicesFilter === 'Due') {
        return false
      }
      return null
    }
  },

  mounted() {
    this.toDate = new Date()
    this.fromDate = new Date()
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1)
    this.search()
  },
  methods: {
    search: _.debounce(function() {
      httpService.post('invoice/search', { fromDate: this.fromDate, toDate: this.toDate, searchPhrase: this.searchPhrase, showInvoicesFilter: this.showInvoicesFilterParam }).then((response) => {
        this.invoices = response.data.invoices

        for (let i = 0; i < this.invoices.length; i++) {
          this.invoices[i].documentType = this.invoices[i].documentType.replace('Credit Memo', this.t('creditDocumentType'))
          this.invoices[i].documentType = this.invoices[i].documentType.replace('Credit_x0020_Memo', this.t('creditDocumentType'))
          this.invoices[i].documentType = this.invoices[i].documentType.replace('Receipt', this.t('receiptDocumentType'))
          this.invoices[i].documentType = this.invoices[i].documentType.replace('Invoice', this.t('invoiceDocumentType'))

          this.invoices[i].displayStatus = this.invoices[i].status
          this.invoices[i].displayStatus = this.invoices[i].displayStatus.replace('NotPaid', this.t('notPaidStatus'))
          this.invoices[i].displayStatus = this.invoices[i].displayStatus.replace('Paid', this.t('paidStatus'))
          this.invoices[i].displayStatus = this.invoices[i].displayStatus.replace('Cancelled', this.t('cancelledStatus'))
          this.invoices[i].displayStatus = this.invoices[i].displayStatus.replace('Overdue', this.t('overdueStatus'))
          this.invoices[i].displayStatus = this.invoices[i].displayStatus.replace('Annulled', this.t('annulledStatus'))
          this.invoices[i].displayStatus = this.invoices[i].displayStatus.replace('Open', this.t('openStatus'))

          this.invoices[i].orderNumber = this.invoices[i].orderNumber.replace(/;$/, '')
          this.invoices[i].orderNumber = this.invoices[i].orderNumber.replaceAll(';', ', ')

          if (this.invoices[i].displayDueDate === '0001-01-01') {
            this.invoices[i].displayDueDate = ''
          }
        }

        this.moreToGet = response.data.moreToGet
      })
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.my-invoice-history {
  min-height: 35rem;
}
.my-invoice-history__filter-grid {
  display: grid;
  gap: measure(quarter);
  margin-bottom: measure(half);
  grid-template-columns: repeat(1, minmax(0, 1fr));

  @include media(medium) {
    grid-template-columns: minmax(0,40%) minmax(0,30%) minmax(0,30%)
  }
}

.my-invoice-history__search-input {
  grid-column: span 3;

  @include media(medium) {
    grid-column: span 1;
  }

}

.my-invoice-history__date-inputs {
  @include media(to-small) {
    grid-column: span 2;
  }
}

.my-invoice-history__column-header {
  @include h2-semi-bold;
  margin-top: 0;
  margin-bottom: measure(eighth) !important;
}

.my-invoice-history__filter-actions {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: measure(full);

  @include media(small) {
    flex-direction: row;
  }
}

.my-invoice-history__filter-actions > * {
  @include media(to-small) {
    &:first-child {
      margin-bottom: measure(half);
    }
  }
}

.my-invoice-history__date-search {
  width: 100%;

  @include media(small) {
    flex-basis: 9.375rem;
    width: auto;
    margin-left: measure(full);
  }

  @include media(medium) {
    align-self: flex-end;
  }
}

.my-invoice-history__table {
  overflow-x: auto;
}

  .my-invoice-history__heading-and-filter-actions {
    display: grid;
    grid-template-columns: minmax(0,40%) minmax(0,18%) minmax(0,22%) minmax(0,20%);
  }

  .show-invoices-filter-radio {
    justify-self: end;
  }

  .my-invoice-history__heading-and-filter-actions .radio__element:checked + .radio__label:before {
    background-color: color(brand-blue-3)  !important;
    border-color: color(green-2);
  }

  .show-invoices-filter-radio > .radio__label:before {
    background-color: color(brand-blue-3)  !important;
    border-color: color(green-2);
  }

  .radio__element:checked + .radio__label:before {
    background-color: color(brand-blue-3)  !important;
    border-color: color(green-2);
  }
</style>
